export const RU_MONTH_NAMES = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];

export function formatPeriodMonthLabel(isoDate: string): string {
  const parts = isoDate.slice(0, 10).split('-');
  if (parts.length < 2) return isoDate;
  const year = Number(parts[0]);
  const monthIdx = Number(parts[1]) - 1;
  const monthName = RU_MONTH_NAMES[monthIdx] ?? parts[1];
  return `${monthName} ${year}`;
}
